//global.$ = global.jQuery = require('jquery');

// import ModuleName from 'module-path';
// let libName = require('library-name');
(function($) {
  // Open Lightbox
  jQuery(".open-lightbox").on("click", function(e) {
    e.preventDefault();
    //var image = jQuery(this).attr('href');
    var iframe = jQuery(this).attr("href");
    jQuery("html").addClass("no-scroll");
    jQuery("body").append(
      '<div class="lightbox-opened"><div class="lightbox-in bg-white rounded-md max-w-5xl mx-auto relative w-full p-3"><div class="responsive-video"><iframe width="315" height="315" src="' +
        iframe +
        '" class="w-full" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe></div></div></div>'
    );
  });
  // // Close Lightbox
  jQuery("body").on("click", ".lightbox-opened", function() {
    jQuery("html").removeClass("no-scroll");
    jQuery(".lightbox-opened").remove();
    jQuery(".book-model").hide();
  });

  ///Books model
  jQuery(".book-model").hide();
  jQuery('.book-open').on('click', function(e) {
      var a = $(this).parent().parent();
      console.log(a.first());
      console.log(a);
      console.log(a.children(":first").data('content'));
      var content = a.children(":first").data('content');
      // console.log('content', content)
      var title = a.children(":first").data('title');
      var booklink = a.children(":first").data('book-link');
      var permalink = a.children(":first").data('permalink');
      var share_url = a.children(":first").data('share-url');
      var thumbnail = a.children(":first").data('thumbnail');
      var authorname = a.children(":first").data('author-name');
      var categories = a.children(":first").data('categories');
      console.log('title', title, share_url);

      var contentdiv = document.getElementById('content');
      var titlediv = document.getElementById('title');
      var booklinkdiv = document.getElementById('booklink');
      //var permalinkdiv = document.getElementById('permalink');
      var thumbnaildiv = document.getElementById('thumbnail');
      var authornamediv = document.getElementById('authorname');
      var categoriesdiv = document.getElementById('categories');

      contentdiv.innerHTML = content;
      titlediv.innerHTML = title;
      authornamediv.innerHTML = authorname;
      categoriesdiv.innerHTML = categories;
      thumbnaildiv.setAttribute("src",thumbnail);
      if (booklink != "") {
          booklinkdiv.classList.remove("btn-disabled");
          booklinkdiv.innerHTML = `Purchase <svg width="35" height="14" viewBox="0 0 40 15" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M39.157 8.2071C39.5475 7.81658 39.5475 7.18341 39.157 6.79289L32.7931 0.42893C32.4025 0.0384053 31.7694 0.0384054 31.3788 0.42893C30.9883 0.819454 30.9883 1.45262 31.3788 1.84314L37.0357 7.5L31.3788 13.1569C30.9883 13.5474 30.9883 14.1805 31.3788 14.5711C31.7694 14.9616 32.4025 14.9616 32.7931 14.5711L39.157 8.2071ZM0.649902 8.5L38.4499 8.5L38.4499 6.5L0.649902 6.5L0.649902 8.5Z" fill="white"/></svg>`;
          booklinkdiv.setAttribute("href", booklink);
      } else {
          booklinkdiv.setAttribute("href", "#");
          booklinkdiv.textContent = "Unavailable";
          booklinkdiv.classList.add("btn-disabled");
      }

      // var twitterURL = 'https://twitter.com/intent/tweet?text='+ title +'&amp;url='+permalink+'&amp;via=TheSandersInst';
      var twitterURL = 'https://twitter.com/share?text='+ title +'&url=' + share_url + '&via=TheSandersInst';
      var facebookURL = 'https://www.facebook.com/sharer/sharer.php?u='+share_url;
      var linkedInURL = 'https://www.linkedin.com/sharing/share-offsite/?url='+share_url+'&amp;title='+ title;
      var email = 'mailto:?subject='+ title + '&body=Check out this POST: '+share_url+'" title="Share by Email';

      document.getElementById('twitter').setAttribute("href",twitterURL);
      document.getElementById('facebook').setAttribute("href",facebookURL);
      document.getElementById('linkedIn').setAttribute("href",linkedInURL);
      document.getElementById('email').setAttribute("href",email);
      document.getElementById('bookcopylink').setAttribute("href",permalink);
      document.getElementById('bookcopyclipboard').setAttribute("data-clipboard-text",permalink);

      jQuery('html').addClass('no-scroll');
      jQuery('.book-model').addClass('active-model');
      jQuery('.book-model').fadeIn();
  });
  jQuery('.book-image').on('click', function(e) {
  // jQuery(document).on("click", ".book-open", function(e) {
    var content = $(this).data("content");
    var title = $(this).data("title");
    var booklink = $(this).data("book-link");
    var permalink = $(this).data("permalink");
    var share_url = $(this).data("share-url");
    var thumbnail = $(this).data("thumbnail");
    var authorname = $(this).data("author-name");
    var categories = $(this).data("categories");

    var contentdiv = document.getElementById("content");
    var titlediv = document.getElementById("title");
    var booklinkdiv = document.getElementById("booklink");
    //var permalinkdiv = document.getElementById('permalink');
    var thumbnaildiv = document.getElementById("thumbnail");
    var authornamediv = document.getElementById("authorname");
    var categoriesdiv = document.getElementById("categories");

    contentdiv.innerHTML = content;
    titlediv.innerHTML = title;
    authornamediv.innerHTML = authorname;
    categoriesdiv.innerHTML = categories;
    thumbnaildiv.setAttribute("src", thumbnail);
    if (booklink != "") {
      booklinkdiv.classList.remove("btn-disabled");
      booklinkdiv.innerHTML = `Purchase <svg width="35" height="14" viewBox="0 0 40 15" fill="none" xmlns="http://www.w3.org/2000/svg"> <path d="M39.157 8.2071C39.5475 7.81658 39.5475 7.18341 39.157 6.79289L32.7931 0.42893C32.4025 0.0384053 31.7694 0.0384054 31.3788 0.42893C30.9883 0.819454 30.9883 1.45262 31.3788 1.84314L37.0357 7.5L31.3788 13.1569C30.9883 13.5474 30.9883 14.1805 31.3788 14.5711C31.7694 14.9616 32.4025 14.9616 32.7931 14.5711L39.157 8.2071ZM0.649902 8.5L38.4499 8.5L38.4499 6.5L0.649902 6.5L0.649902 8.5Z" fill="white"/></svg>`;
      booklinkdiv.setAttribute("href", booklink);
    } else {
      booklinkdiv.setAttribute("href", "#");
      booklinkdiv.textContent = "Unavailable";
      booklinkdiv.classList.add("btn-disabled");
    }

    // var twitterURL = 'https://twitter.com/intent/tweet?text='+ title +'&amp;url='+permalink+'&amp;via=TheSandersInst';
    var twitterURL =
      "https://twitter.com/share?text=" +
      title +
      "&url=" +
      share_url +
      "&via=TheSandersInst";
    var facebookURL =
      "https://www.facebook.com/sharer/sharer.php?u=" + share_url;
    var linkedInURL =
      "https://www.linkedin.com/sharing/share-offsite/?url=" +
      share_url +
      "&amp;title=" +
      title;
    var email =
      "mailto:?subject=" +
      title +
      "&body=Check out this POST: " +
      share_url +
      '" title="Share by Email';

    document.getElementById("twitter").setAttribute("href", twitterURL);
    document.getElementById("facebook").setAttribute("href", facebookURL);
    document.getElementById("linkedIn").setAttribute("href", linkedInURL);
    document.getElementById("email").setAttribute("href", email);
    document.getElementById("bookcopylink").setAttribute("href", permalink);
    document
      .getElementById("bookcopyclipboard")
      .setAttribute("data-clipboard-text", permalink);

    jQuery("html").addClass("no-scroll");
    jQuery(".book-model").addClass("active-model");
    jQuery(".book-model").fadeIn();
  });
  // // Close Books model
  jQuery("body").on("click", ".close-popup", function() {
    jQuery("html").removeClass("no-scroll");
    jQuery(".book-model").hide();
  });
  jQuery(".cat-slug").on("click", function(e) {
    e.preventDefault();
    var slug = $(this).data("value");
    console.log(slug);
    $(".issue-book-filter")
      .val(slug)
      .trigger("change");
  });

  jQuery(".author-slug").on("click", function(e) {
    e.preventDefault();
    var author = $(this).data("value");
    // console.log(author);
    $("#author-book-filter")
      .val(author)
      .trigger("change");
  });
  jQuery(".post-cat-slug").on("click", function(e) {
    e.preventDefault();
    var slug = $(this).data("value");
    // console.log(slug);
    $("#issue-filter")
      .val(slug)
      .trigger("change");
    $("html, body").animate({ scrollTop: 0 }, "slow");
  });

  // jQuery('body').on('scroll', '.close-popup', function() {
  //   console.log(1);
  // });

  // Video Pop up

  jQuery(".video-link").on("click", function(e) {
    console.log(1);
    e.preventDefault();
    //var e = document.getElementById("top");

    var content = $(this).data("content");
    var title = $(this).data("title");
    var booklink = $(this).data("video-link");
    var permalink = $(this).data("permalink");
    var categories = $(this).data("categories");

    var contentdiv = document.getElementById("content");
    var titlediv = document.getElementById("title");
    var booklinkdiv = document.getElementById("video_link");
    var categoriesdiv = document.getElementById("categories");

    contentdiv.innerHTML = content;
    titlediv.innerHTML = title;
    categoriesdiv.innerHTML = categories;
    booklinkdiv.setAttribute("src", booklink);

    contentdiv.scrollIntoView({
      block: "start",
      behavior: "smooth",
      inline: "start",
    });
  });
})(jQuery);

document.addEventListener("DOMContentLoaded", function(event) {
  // wait until window, stylesheets, images, links, and other media assets are loaded
  window.onload = function() {
    ////Sal animation
    let salAnimate = sal({
      threshold: 0.2,
      once: true,
    });

    salAnimate.enable();
    // Toggle Menu - Toggle Menu Function
    jQuery("#toggle").click(function() {
      jQuery(this).toggleClass("active");
      jQuery("#navbarNavDropdown").toggleClass("open");
      jQuery(".mobile-logo").toggleClass("mobile-logo-light");
      jQuery(".site-header").toggleClass("header-open-fixed");
      jQuery("html").toggleClass("hidescroll");
    });

    // Hamburger Menu - Remove the Hamburger menu Overlay after click
    jQuery("#main-menu li a").click(function() {
      jQuery("#navbarNavDropdown").removeClass("open");
      jQuery(".mobile-logo").removeClass("mobile-logo-light");
      jQuery("#toggle").removeClass("active");
      jQuery(".site-header").removeClass("header-open-fixed");
    });
    jQuery("#main-menu li.menu-item-has-children").append(
      "<span class='dot-triggle hidden'><i class='fas fa-caret-down'></i></span>"
    );
    jQuery(".dot-triggle").on("click", function(e) {
      e.preventDefault();
      var currentBox = jQuery(this)
        .siblings("#main-menu .sub-menu")
        .toggleClass("menu-active-mobile");
      jQuery("#main-menu .sub-menu.active-team")
        .not(currentBox)
        .removeClass("menu-active-mobile");

      var addclassnew = jQuery(this)
        .closest(".dot-triggle")
        .toggleClass("dot-active-mobile");
      jQuery(".dot-triggle.active-team")
        .not(addclassnew)
        .removeClass("dot-active-mobile");
    });

    // Header Search Function
    jQuery("#toggleSearch").click(function(e) {
      //alert(1)
      var searchText = jQuery("#search-field").val();

      if (
        (searchText || searchText != "") &&
        jQuery("#toggleSearch").hasClass("toggleSearchIcon")
      ) {
        jQuery("#suggestions").hide();
        jQuery("#search-form").submit();
      } else {
        jQuery(this).toggleClass("toggleSearchIcon");
        jQuery(".head-search-popup").toggleClass("head-search-popup-open");
        jQuery("#suggestions").hide();
      }
    });
    jQuery("#search-field").blur(function(e) {
      setTimeout(function() {
        jQuery("#toggleSearch").toggleClass("toggleSearchIcon");
        jQuery(".head-search-popup").toggleClass("head-search-popup-open");
        jQuery("#suggestions").hide();
      }, 500);
    });

    // Header - Add Sticky Header Function.
    jQuery(document).on("scroll", function() {
      if (jQuery(document).scrollTop() > 150) {
        jQuery(".site-header").addClass("sticky-header");
      } else {
        jQuery(".site-header").removeClass("sticky-header");
      }
    });

    // Scroll to Section - Add Scroll to Section Function.
    jQuery(document).ready(function() {
      document
        .querySelectorAll('.scroll-to-section a[href^="#"]')
        .forEach((anchor) => {
          anchor.addEventListener("click", function(e) {
            e.preventDefault();
            const element = document.querySelector('.timeline-hero-section');
            if (jQuery(window).width() < 480 || jQuery(window).height() < 480) {
              jQuery('html,body').animate({scrollTop: element.scrollHeight - 45}, 1300);
            } else {
              jQuery('html,body').animate({scrollTop: element.scrollHeight}, 1300);
            }
            // document.querySelector(this.getAttribute("href")).scrollIntoView({
            //   behavior: "smooth",
            // });
          });
        });
    });

    //Accordiun Function
    jQuery(".accordion-title").click(function(e) {
      e.preventDefault();
      var $this = jQuery(this);
      jQuery(".accordion-title").removeClass("open-acc");
      $this.addClass("open-acc");
      if ($this.next().hasClass("show")) {
        $this.next().removeClass("show");
        $this.next().slideUp(350);
        jQuery(".accordion-title").removeClass("open-acc");
      } else {
        $this
          .parent()
          .parent()
          .find(".inner")
          .removeClass("show");
        $this
          .parent()
          .parent()
          .find(".inner")
          .slideUp(350);
        $this.next().toggleClass("show");
        $this.next().slideToggle(350);
      }
    });

    jQuery(document).ready(function() {
      var swiper = new Swiper("#hero-slider", {
        loop: true,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev",
        },
        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
        breakpoints: {
          980: {
            navigation: {
              nextEl: ".swiper-button-next",
              prevEl: ".swiper-button-prev",
              disabledClass: "disabled_swiper_button",
            },
          },
        },
      });
    });
    jQuery(".post-content a").click(function() {
      this.target = "_blank";
    });
  };
  //Donation Form
  jQuery(".other-amount").click(function() {
    jQuery(this).toggleClass("other-amount-activate");
    jQuery(".other-amount-txt").toggleClass("other-amount-txt-activate");
  });
  jQuery("#donation_link").click(function() {
    var amount = jQuery(".other-amount-txt").val();
    var donationUrl =
      "https://secure.actblue.com/contribute/page/sandersinstitute?amount=" +
      amount;
    document.getElementById("donation_link").setAttribute("href", donationUrl);
  });

  //Search Function
  // jQuery('.suggestion').click( function(event) {
  //     event.preventDefault();
  //     var dataValue = jQuery(this).data('value');
  //         jQuery("#search-field").val(dataValue);
  //         jQuery( "#search-form" ).submit();
  //         jQuery('#suggestions').hide();

  // });
  // jQuery('.search-field').click(function(e) {
  //     e.preventDefault();
  //     jQuery('#suggestions').show();
  // });

  // jQuery(".search-field").keypress(function(){
  //     jQuery('#suggestions').hide();
  //   });

  //   jQuery(document).mouseup(function(e)
  //   {
  //       var suggestionContainer = jQuery(".suggestion");

  //       // if the target of the click isn't the container nor a descendant of the container
  //       if (!suggestionContainer.is(e.target) && suggestionContainer.has(e.target).length === 0)
  //       {
  //         suggestionContainer.hide();
  //       }
  //   });
  // jQuery("#search-field").val('');
  // jQuery(document).on('click', function(e) {
  //     if (jQuery(e.target).closest("suggestion").length === 0) {
  //         jQuery("#suggestions").hide();
  //     }
  //  });
  jQuery(document).ready(function() {
    var bttn = document.getElementsByClassName("bttn");
    var clipboard = new ClipboardJS(bttn);

    clipboard.on("success", function(e) {
      console.info("Action:", e.action);
      console.info("Text:", e.text);
      console.info("Trigger:", e.trigger);
    });

    clipboard.on("error", function(e) {
      console.info("Action:", e.action);
      console.info("Text:", e.text);
      console.info("Trigger:", e.trigger);
    });
  });


});
